import ppSacCustomOptions from './ppSacCustomOptions';

export default function parserContactUs(contactInfo, formFields, isFinalIntent, chatParams) {
  // checking for SAC custom options
  const sacOptions = ppSacCustomOptions(contactInfo, formFields, isFinalIntent, chatParams);
  if (sacOptions) {
    return {
      phoneNumber: [sacOptions.phoneValue],
      customerHour: {
        hoursOfService: sacOptions.HoursOfOperation,
      },
      isPhonePresent: true,
      webPin: contactInfo && contactInfo.web_pin ? contactInfo.web_pin : null,
    };
  }

  return {
    phoneNumber: contactInfo.isphonePresent ? contactInfo.phoneNumbers : [],
    specialInstruction: contactInfo.isInstructionPresent ? contactInfo.Special_Instruction : '',
    webPin: contactInfo.web_pin,
    mtsPhone: contactInfo.isMTSPresent ? contactInfo.Account_Manager_MTS_Display : '',
    generalMTS: contactInfo.isMTSPresent ? contactInfo.General_MTS_Display : '',
    generalPhoneNumber: contactInfo.General_Phone_Number || '',
    amPhone: contactInfo.Account_Manager_Phone_Number || '',
    amFlag: contactInfo.Account_Manager_Flag_Name || '',
    accountManagerEmail: contactInfo.Account_Manager_Email_Address || '',
    customerHour: {
      hoursOfService: contactInfo.Hours_of_Service_1 || '',
      generalTime1: contactInfo.General_Available_Time_1 || '',
      generalTime2: contactInfo.General_Available_Time_2 || '',
      amTime1: contactInfo.Account_Manager_Available_Time_1 || '',
      amTime2: contactInfo.Account_Manager_Available_Time_2 || '',
      amPerCall: contactInfo.Account_Manager_Cost_Per_Call || '',
    },
  };
}
